import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import { PrintDesignReportsVM } from './PrintDesignReportsVM';
import { WaterwayDesignReportComponent } from 'cd-eft/components/Reports/WaterwayDesignReport/WaterwayDesignReportComponent';
import { TerraceDesignReport } from 'cd-eft/components/Reports/TerraceDesignReport/TerraceDesignReport';

interface IPrintDesignReportsProps {
  project: any;
  printButtonClicked: boolean;
  reportData?: any;
}

export const PrintDesignReportsComponent = (props: IPrintDesignReportsProps) => {
  const vm = useRef(new PrintDesignReportsVM(props)).current;

useEffect  (() => {
    const loadReports = async () => {
      if (props.printButtonClicked) {
        await vm.getTerraceSummaryReport(props.printButtonClicked);
        await vm.generateWaterwayDesignReport(props.printButtonClicked);
      }
    };
    loadReports();
  }, [props.printButtonClicked]);

  return (
    <div className="print-report">
      {/* Waterways */}
      {vm.waterwayDesignReportData &&
        vm.waterwayDesignReportData.length > 0 &&
        vm.waterwayDesignReportData.map((el, i) => (
          <WaterwayDesignReportComponent
            key={`${i}-${el.alignmentDesignElementJsonId}`}
            {...JSON.parse(el)}
            {...props}
          />
        ))}

      {/* Terraces */}
      {props && props.reportData && <TerraceDesignReport {...props} />}
      {vm.terraceDesignReportObj &&
        vm.terraceDesignReportObj.length > 0 &&
        vm.terraceDesignReportObj.map((el, i) => (
          <TerraceDesignReport
            key={`${i}`} //for multiple terrace
            {...props}
            reportData={vm.terraceDesignReportObj[i]}
          />
        ))}
    </div>
  );
};

export const PrintDesignReports = observer(PrintDesignReportsComponent);
